"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const organisms_1 = require("..");
function AdminAcceptNotification({ notification, onSelect, selected, hasSelected, }) {
    var _a;
    return ((0, jsx_runtime_1.jsx)(organisms_1.Notification, { notification: notification, selected: selected, onSelect: onSelect, isGroup: true, description: (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.adminAccept), title: (_a = notification === null || notification === void 0 ? void 0 : notification.user) === null || _a === void 0 ? void 0 : _a.name, hasSelected: hasSelected, "data-e2e": 'AdminAcceptNotification_Notification' }));
}
exports.default = AdminAcceptNotification;
